import LinkCard from './link-card';
export default LinkCard;
